import type { AppEnvName } from '@/features/auth/types';
import type { DispensingLabel } from './types';

/**
 * Only the production API environment may start a physical print. Everywhere
 * else (staging, training, test, local, or an unknown value) the label sheet
 * is a marked preview. This cannot stop a browser-level print of the page.
 */
export function canPhysicallyPrint(appEnv: AppEnvName | undefined): boolean {
  return appEnv === 'production';
}

/**
 * The leaflet QR address of a label, or null. Never invents one: an absent,
 * empty or non-http(s) value means no QR is drawn.
 */
export function leafletQrOf(label: DispensingLabel): string | null {
  const url = label.leafletQrUrl;
  if (typeof url !== 'string' || url.trim() === '') return null;
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:'
      ? url
      : null;
  } catch {
    return null;
  }
}
